import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export class ControlValidators {
  public static requiredIfOneHasValue(controlsNames: string[]): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const atLeastOneHasValue: boolean = Object.keys(formGroup.value).some(
        (controlName) => formGroup.get(controlName)?.value,
      );

      if (atLeastOneHasValue) {
        controlsNames
          .filter(
            (controlName: string) => !formGroup.get(controlName)?.hasValidator(Validators.required),
          )
          .forEach((controlName: string) => {
            formGroup.get(controlName)?.addValidators(Validators.required);
            formGroup.get(controlName)?.updateValueAndValidity();
          });
      } else {
        controlsNames
          .filter((controlName: string) =>
            formGroup.get(controlName)?.hasValidator(Validators.required),
          )
          .forEach((controlName: string) => {
            formGroup.get(controlName)?.removeValidators(Validators.required);
            formGroup.get(controlName)?.updateValueAndValidity();
          });
      }

      return null;
    };
  }

  public static emailFormatValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return control.value && !emailPattern.test(control.value) ? { invalidEmail: true } : null;
    };
  }

  public static noSpecialCharactersValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const forbiddenChars = /[^a-zA-Z0-9@._-]/;
      return forbiddenChars.test(control.value) ? { noSpecialChars: true } : null;
    };
  }

  public static emailMatchValidator(refControlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const controls = control.parent?.controls as Record<
        string,
        AbstractControl<unknown, unknown>
      >;
      if (controls && control.value === controls[refControlName]?.value) {
        return null;
      }
      return { emailMisMatch: true };
    };
  }

  public static emailsMatchValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const email = control.get('email')?.value;
      const emailConfirmation = control.get('emailConfirmation')?.value;
      return email && emailConfirmation && email !== emailConfirmation
        ? { emailMisMatch: true }
        : null;
    };
  }
}
